import React from "react";
import { createColumnHelper } from "@tanstack/react-table";

const columnHelper = createColumnHelper<any>();

export const getChangeLogColumns = () => [
    columnHelper.accessor("modifiedAt", {
      id: "modifiedAt",
      header: "Timestamp",    
      cell: (cellProps) => (
        <div>{cellProps.getValue().toUiDateTimeFormat()}</div>
      ),
      size: 166,
      minSize: 166,
    }),
    columnHelper.accessor("modifiedBy", {
      id: "modifiedBy",
      header: "Email ID",    
      cell: (cellProps) => (
        <div>{cellProps.getValue()}</div>
      ),
      size: 166,
      minSize: 166,
    }),
    columnHelper.accessor("changeDescription", {
      id: "changeDescription",
      header: "Change Description",    
      cell: (cellProps) => (
        <div title={cellProps.row.original.showFullChangeDescription ? cellProps.row.original.fullChangeDescription : ""}>{cellProps.getValue()}</div>
      ),
      size: 400,
      minSize: 400,
    }),
];